<template>
  <section class="container">
    <div class="management_top_box mb-3">
      <h4>{{ $t("management.pdfManagement") }}</h4>
    </div>
    <div class="brick_box">
      <table class="write_tbl responsive_tbl">
        <tbody>
          <tr>
            <th>{{ $t("management.text") }}</th>
            <td>
              <input
                type="text"
                name="className"
                v-model="pdf.text"
                class="int_type01"
                maxlength="40"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.fontSize") }}</th>
            <td>
              <input
                type="number"
                v-model="pdf.font_size"
                class="int_type01"
                max="150"
                maxlength="3"
                v-validate="'required'"
                placeholder="max : 100px"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.useYN") }}</th>
            <td>
              <select
                v-model="pdf.use"
                class="int_type01 mgt_seltype"
                v-validate="'required'"
              >
                <option>Y</option>
                <option>N</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list_bottom_bt">
        <button @click="savePdf" class="btn btn-primary btn-lg m-1">
          {{ $t("common.save") }}
        </button>
      </div>
    </div>
  </section>
</template>
<script>
import { getPdfWaterMark, savePdfWaterMark } from "@/api/pdf";
export default {
  data() {
    return {
      pdf: {},
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getPdfWaterMark();
        this.pdf = data.pdf;
      } catch (error) {
        console.log(error);
      }
    },
    async savePdf() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      if (this.pdf.font_size > 100) {
        alert(this.$t("alert.plzCheckAllValues"));
        return;
      }
      if (!confirm(this.$t("alert.save"))) return;
      try {
        const { data } = await savePdfWaterMark(this.pdf);
        if (data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
          return;
        }
        if (data.status) {
          alert(this.$t("alert.changedSuccessfully"));
          this.pdf = "";
          this.fetchData();
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
